// Authenticated fetch. A module-level token getter is populated by
// <ClerkTokenBridge /> (which lives inside ClerkProvider) so the data hooks
// — which are plain functions, not components — can attach the Clerk session
// token without each needing access to the React Clerk context.

type TokenGetter = () => Promise<string | null>;

let tokenGetter: TokenGetter | null = null;

export function setAuthTokenGetter(getter: TokenGetter | null): void {
	tokenGetter = getter;
}

export async function authFetch(
	input: RequestInfo | URL,
	init: RequestInit = {}
): Promise<Response> {
	const headers = new Headers(init.headers);
	if (tokenGetter && !headers.has("Authorization")) {
		try {
			const token = await tokenGetter();
			if (token) headers.set("Authorization", `Bearer ${token}`);
		} catch {
			// No token available; the request proceeds and the API returns 401.
		}
	}
	return fetch(input, { ...init, headers });
}
